module.exports = __webpack_public_path__ + "static/bemyndigande-2024-1cc5818a5e32edd428d4bc4ad9b84383.pdf";